import { IsNotEmpty } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";

export class LeavesDTO{
    empleavesId:number;
    @ApiProperty()
    @IsNotEmpty()
    typeOfLeave: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Leave alloted should not be empty'})
    leavesAlloted: number;
    
    @ApiProperty()
    leavesUsed: number;
    @ApiProperty()
    leavesAvailable: number;
}